import { Dialog } from "@progress/kendo-react-dialogs";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "src/util/notify";
import { useNavigate, useLocation } from "react-router";
import { useSelector } from "react-redux";
import InputKendoRct from "../../control-components/input/input";
import ErrorHelper from "../../helper/error-helper";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import APP_ROUTES from "../../helper/app-routes";
import DatePickerKendoRct from "../../control-components/date-picker/date-picker";
import { Error, Label } from "@progress/kendo-react-labels";
import ValidationHelper from "../../helper/validation-helper";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import { displayDate } from "../../util/utility";
import { TrainingServices } from "../../services/trainingServices";
import Loader from "../../control-components/loader/loader";
import moment from "moment";
function AddTrainingLink({ onClose, selectedId }) {
  const regionData = useSelector((state) => state.getRegion);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [settingError, setSettingError] = useState(false);
  const [domainNameAvailabe, setDomainNameAvailable] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [compError, setCompError] = useState("");
  const vHelper = ValidationHelper();
  let [fields, setFields] = useState({
    url: "",
    title: "",
    description: "",
    trainingDate: new Date(),
    trainingTime: "",
    expirationDate: new Date(),
    expirationTime: "",
    textOnLink : "",
  });
  useEffect(() => {
    if (state) {
      getTrainingLinkById();
    }
  }, []);
  const getTrainingLinkById = () => {
    const TrainingDateTime = moment(state.trainingDate).local();
    const ExpirationDateTime = moment(state.expirationDate).local();
    setFields((prevFields) => ({
      ...prevFields,
      url: state.url,
      title: state.title,
      textOnLink: state.textOnLink,
      description: state.description,
      trainingDate: state?.trainingDate === null ? new Date() : TrainingDateTime.format("YYYY-MM-DD"),
      trainingTime: state?.trainingDate === null
        ? new Date()
        : new Date(
          displayDate(new Date(), "MM/DD/yyyy") +
          " " +
          TrainingDateTime.format("HH:mm")
        ),
      expirationDate: state?.expirationDate === null ? new Date() : ExpirationDateTime.format("YYYY-MM-DD"),
      expirationTime: state?.expirationDate === null
        ? new Date()
        : new Date(
          displayDate(new Date(), "MM/DD/yyyy") +
          " " +
          ExpirationDateTime.format("HH:mm")
        ),
    }));
  };
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!fields.url) {
      formIsValid = false;
      errors["url"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.title) {
      formIsValid = false;
      errors["title"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.trainingTime) {
      formIsValid = false;
      errors["trainingTime"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.expirationTime) {
      formIsValid = false;
      errors["expirationTime"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.trainingDate) {
      formIsValid = false;
      errors["trainingDate"] = ErrorHelper.FIELD_BLANK;
    } else if (fields.trainingDate && fields.expirationDate) {
      let error = vHelper.startDateLessThanEndDateValidator(
        fields.trainingDate,
        fields.expirationDate,
        "startDate",
        "expirationDate"
      );
      if (error && error.length > 0) {
        setCompError(error);
        formIsValid = false;
      }
    }
    setErrors(errors);
    return formIsValid;
  };
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };
  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      if (state) {
        updateTrainingLink();
      } else {
        addTrainingLink();
      }
    }
  };
  const addTrainingLink = async () => {
    setLoading(true);
    await TrainingServices
      .addTrainingLink(fields)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(NOTIFICATION_MESSAGE.TRAINING_LINK_ADDED);
        navigate(APP_ROUTES.TRAINING_LINKS);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };
  const updateTrainingLink = async () => {
    setLoading(true);
    await TrainingServices
      .updateTrainingLink(fields, state)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(NOTIFICATION_MESSAGE.TRAINING_LINK_UPDATED);
        navigate(APP_ROUTES.TRAINING_LINKS);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };
  const handleCancel = () => {
    navigate(APP_ROUTES.TRAINING_LINKS);
  };
  return (
    <>
      <div className="client-accept notenetic-container placeholder-size">
        <h4 h4 className="address-title text-grey mb-5 ">
          <span className="f-24">
            {state ? "Edit Training Link" : "Add Training Link"}
          </span>
        </h4>
        <div className="row inputFieldBox">
          <div className="mb-3 col-lg-6 col-md-6 col-12">
            <InputKendoRct
              value={fields.url}
              onChange={handleChange}
              name="url"
              label="URL"
              error={fields.url === "" && errors.url}
              validityStyles={settingError}
              required={true}
              className="form-control"
              placeholder={"Url"}
            />
          </div>
          <div className="mb-3 col-lg-6 col-md-6 col-12">
            <InputKendoRct
              type="text"
              validityStyles={settingError}
              value={fields.title}
              onChange={handleChange}
              name="title"
              label="Title"
              error={fields.title === "" && errors.title}
              required={true}
              placeholder={"Title Name"}
              className="form-control fw-2 "
            />
          </div>
          <div className="mb-3 col-lg-6 col-md-6 col-12">
            <InputKendoRct
              type="text"
              value={fields.textOnLink}
              onChange={handleChange}
              name="textOnLink"
              label="Text on Link"
              //error={fields.textOnLink === "" && errors.title}
              required={false}
              placeholder={"Text on Link"}
              className="form-control fw-2 "
            />
          </div>
          <div className="mb-3 col-lg-6 col-md-6 col-12 date-field">
            <DatePickerKendoRct
              onChange={handleChange}
              placeholder=""
              value={fields.trainingDate ? new Date(fields.trainingDate) : new Date()}
              name={"trainingDate"}
              title={"Start Date"}
              label={"Start Date"}
              error={!fields?.trainingDate && errors.trainingDate}
              required={true}
              validityStyles={!!errors.trainingDate}
              min={new Date ()}
            />
            {compError && <Error>{compError}</Error>}
          </div>
          <div className="mb-3 col-lg-6 col-md-6 col-12 date-field">
            <TimePicker
              name={"trainingTime"}
              fillMode={"solid"}
              size={"medium"}
              title={"Start Time"}
              label={"Start Time"}
              value={fields?.trainingTime}
              onChange={handleChange}
            />
            {!fields?.trainingTime && errors.trainingTime && (
              <Error> {errors.trainingTime}</Error>
            )}
          </div>
          <div className="mb-3 col-lg-6 col-md-6 col-12 date-field">
            <DatePickerKendoRct
              onChange={handleChange}
              placeholder=""
              value={fields.expirationDate ? new Date(fields.expirationDate) : new Date()}
              name={"expirationDate"}
              title={"Expiration Date"}
              label={"Expiration Date"}
              error={!fields?.expirationDate && errors.expirationDate}
              required={true}
              validityStyles={!!errors.expirationDate}
              min={new Date ()}
            />
          </div>
          <div className="mb-3 col-lg-6 col-md-6 col-12 date-field">
            <TimePicker
              name={"expirationTime"}
              fillMode={"solid"}
              size={"medium"}
              title={"Expiration Time"}
              label={"Expiration Time"}
              value={fields?.expirationTime}
              onChange={handleChange}
            />
            {!fields?.expirationTime && errors.expirationTime && (
              <Error> {errors.expirationTime}</Error>
            )}
          </div>
          <div className="mb-3 col-lg-12 col-md-12 col-12">
            <InputKendoRct
              type="text"
              validityStyles={settingError}
              value={fields.description}
              onChange={handleChange}
              name="description"
              label="Description"
              error={fields.description === "" && errors.description}
              // required={true}
              placeholder={"Description"}
              className="form-control fw-2 "
            />
          </div>
        </div>
      </div>
      {loading == true && <Loader />}
      <div className="d-fl">
        <button
          className="green-btn btn-primary btn-space mr-3"
          onClick={handleSubmit}
        >
          {state ? "Update" : "Add"}
        </button>
        <button className="btn grey-secondary btn-space" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </>
  );
}
export default AddTrainingLink;

